import React from 'react';
import './GameOverScreen.css';

const GameOverScreen = ({ 
  winner, 
  isGameDraw, 
  gameMode, 
  playerNames, 
  gameTime, 
  onAction
}) => {
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    const ms = Math.floor((milliseconds % 1000) / 10); // Show centiseconds (0-99)
    return `${mins}:${secs.toString().padStart(2, '0')}:${ms.toString().padStart(2, '0')}`;
  };

  const getWinnerText = () => {
    if (isGameDraw) {
      return "It's a Draw!";
    }
    
    if (gameMode === 'pvc') {
      return winner === 1 ? `${playerNames.red} Wins!` : 'Computer Wins!';
    } else {
      return winner === 1 ? `${playerNames.red} Wins!` : `${playerNames.yellow} Wins!`;
    }
  };

  const getWinnerColor = () => {
    if (isGameDraw) return 'blue';
    return winner === 1 ? 'red' : 'yellow';
  };

  return (
    <div className="game-over-screen">
      <div className="game-over-background">
        <div className={`game-over-banner ${getWinnerColor()}`}>
          <h1>Connect 4</h1>
        </div>
        
        <div className="game-over-content">
          <div className={`winner-announcement ${getWinnerColor()}`}>
            <h2>{getWinnerText()}</h2>
            {!isGameDraw && (
              <div className={`winner-piece ${getWinnerColor()}`}></div>
            )}
          </div>
          
          <div className="game-stats">
            <div className="stat-item">
              <span className="stat-label">Game Time:</span>
              <span className="stat-value">{formatTime(gameTime)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Game Mode:</span>
              <span className="stat-value">
                {gameMode === 'pvc' ? 'Player vs Computer' : 'Player vs Player'}
              </span>
            </div>
          </div>
          
          <div className="game-over-buttons">
            <button 
              className="game-over-btn restart-btn"
              onClick={() => onAction('restart')}
            >
              Restart
            </button>
            
            <button 
              className="game-over-btn menu-btn"
              onClick={() => onAction('menu')}
            >
              Back
            </button>
            
            <button 
              className="game-over-btn exit-btn"
              onClick={() => onAction('exit')}
            >
              Exit Game
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameOverScreen;
